const translations = {
  // ─── Common / Shared ────────────────────────────────
  common: {
    fr: {
      destockpro: 'DestockPro',
      slogan: 'La marketplace du déstockage entre professionnels',
      login: 'Connexion',
      register: 'Inscription',
      signup: "S'inscrire",
      logout: 'Déconnexion',
      dashboard: 'Tableau de bord',
      messages: 'Messages',
      admin: 'Administration',
      publish: 'Publier une annonce',
      search: 'Rechercher',
      cancel: 'Annuler',
      save: 'Enregistrer',
      delete: 'Supprimer',
      edit: 'Modifier',
      close: 'Fermer',
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      view: 'Voir',
      all: 'Tous',
      yes: 'Oui',
      no: 'Non',
      back: 'Retour',
      next: 'Suivant',
      previous: 'Précédent',
      professional: 'Professionnel',
      listings: 'Annonces',
      contact: 'Contact',
      about: 'À propos',
      howItWorks: 'Comment ça marche',
      turnkeyService: 'Service clés en main',
      faq: 'FAQ',
      terms: "Conditions d'utilisation",
      privacy: 'Confidentialité',
      joinDestockpro: 'Rejoindre DestockPro',
      browseListings: 'Parcourir les annonces',
      online: 'en ligne',
      realtime: 'Temps réel',
      reconnecting: 'Reconnexion...',
      delivery: 'Livraison',
      pickup: 'Retrait sur place',
      invoice: 'Facture disponible',
      warranty: 'Garantie',
      verified: 'Entreprise vérifiée',
      topAd: 'Top annonce',
      sponsored: 'Sponsorisé',
      unit: 'pièce',
      newLabel: 'Nouvelle',
      add: 'Ajouter',
      available: 'disponible(s)',
      deliveryPossible: 'Livraison possible',
      pickupOnSite: 'Retrait sur place',
      addedToFavorites: 'Ajouté aux favoris',
      removedFromFavorites: 'Retiré des favoris',
      vatExcl: 'HTVA',
      installApp: 'Installer l\'application',
    },
    nl: {
      destockpro: 'DestockPro',
      slogan: 'De marktplaats voor professionele destocking',
      login: 'Inloggen',
      register: 'Registreren',
      signup: 'Registreren',
      logout: 'Uitloggen',
      dashboard: 'Dashboard',
      messages: 'Berichten',
      admin: 'Administratie',
      publish: 'Advertentie plaatsen',
      search: 'Zoeken',
      cancel: 'Annuleren',
      save: 'Opslaan',
      delete: 'Verwijderen',
      edit: 'Bewerken',
      close: 'Sluiten',
      loading: 'Laden...',
      error: 'Fout',
      success: 'Succes',
      view: 'Bekijken',
      all: 'Alle',
      yes: 'Ja',
      no: 'Nee',
      back: 'Terug',
      next: 'Volgende',
      previous: 'Vorige',
      professional: 'Professioneel',
      listings: 'Advertenties',
      contact: 'Contact',
      about: 'Over ons',
      howItWorks: 'Hoe werkt het',
      turnkeyService: 'Sleutel-op-de-deur dienst',
      faq: 'FAQ',
      terms: 'Gebruiksvoorwaarden',
      privacy: 'Privacybeleid',
      joinDestockpro: 'Word lid van DestockPro',
      browseListings: 'Bekijk advertenties',
      online: 'online',
      realtime: 'Realtime',
      reconnecting: 'Opnieuw verbinden...',
      delivery: 'Levering',
      pickup: 'Afhalen ter plaatse',
      invoice: 'Factuur beschikbaar',
      warranty: 'Garantie',
      verified: 'Geverifieerd bedrijf',
      topAd: 'Topadvertentie',
      sponsored: 'Gesponsord',
      unit: 'stuk',
      newLabel: 'Nieuw',
      add: 'Toevoegen',
      available: 'beschikbaar',
      deliveryPossible: 'Levering mogelijk',
      pickupOnSite: 'Afhalen ter plaatse',
      addedToFavorites: 'Toegevoegd aan favorieten',
      removedFromFavorites: 'Verwijderd uit favorieten',
      vatExcl: 'BTW excl.',
      installApp: 'App installeren',
    },
  },

  // ─── Header ─────────────────────────────────────────
  header: {
    fr: {
      myAccount: 'Mon compte',
      myListings: 'Mes annonces',
      publishAd: 'Publier',
    },
    nl: {
      myAccount: 'Mijn account',
      myListings: 'Mijn advertenties',
      publishAd: 'Plaatsen',
    },
  },

  // ─── Footer ─────────────────────────────────────────
  footer: {
    fr: {
      marketplace: 'Marketplace',
      home: 'Accueil',
      allListings: 'Toutes les annonces',
      publishAd: 'Publier une annonce',
      professionals: 'Professionnels',
      createAccount: 'Créer un compte',
      sellEquipment: 'Vendre du matériel',
      buyEquipment: 'Acheter du matériel',
      information: 'Informations',
      contactUs: 'Nous contacter',
      turnkeyService: 'Service clés en main',
      legal: 'Légal',
      allRightsReserved: 'Tous droits réservés',
    },
    nl: {
      marketplace: 'Marktplaats',
      home: 'Home',
      allListings: 'Alle advertenties',
      publishAd: 'Advertentie plaatsen',
      professionals: 'Professionals',
      createAccount: 'Account aanmaken',
      sellEquipment: 'Materiaal verkopen',
      buyEquipment: 'Materiaal kopen',
      information: 'Informatie',
      contactUs: 'Contacteer ons',
      turnkeyService: 'Sleutel-op-de-deur dienst',
      legal: 'Juridisch',
      allRightsReserved: 'Alle rechten voorbehouden',
    },
  },

  // ─── Home Page ──────────────────────────────────────
  home: {
    fr: {
      heroTitle: 'Déstockage entre professionnels',
      heroSlogan: 'Donnez une seconde vie à votre stock dormant — publication en 5 minutes.',
      searchPlaceholder: 'Rechercher du matériel...',
      searchBtn: 'Rechercher',
      heroRegisterLink: 'Pas encore inscrit ? Créer un compte gratuitement',
      latestListings: 'Dernières annonces',
      latestSubtitle: 'Matériel récemment publié par nos vendeurs professionnels',
      viewAll: 'Voir tout',
      viewAllListings: 'Voir toutes les annonces',
      noListingsYet: 'Aucune annonce pour le moment',
      statActiveListings: 'annonces actives',
      statVerifiedCompanies: 'entreprises vérifiées',
      statSectors: 'secteurs couverts',
      statNoCommission: 'Sans commission · Sans abonnement',
      howItWorksTitle: 'Comment ça marche',
      howItWorksSubtitle: 'DestockPro facilite la mise en relation entre professionnels en 3 étapes simples.',
      step1Title: 'Publiez votre matériel',
      step1Desc: 'Créez votre annonce en quelques minutes avec photos, prix et détails.',
      step2Title: 'Trouvez du matériel',
      step2Desc: 'Recherchez parmi les annonces de professionnels et filtrez par secteur.',
      step3Title: 'Échangez et concluez',
      step3Desc: 'Contactez le vendeur, négociez et organisez la transaction.',
      ctaTitle: 'Prêt à démarrer ?',
      ctaText: "Rejoignez DestockPro et commencez à vendre ou acheter du matériel professionnel en Belgique, France, Luxembourg et Pays-Bas.",
      ctaBtn: 'Créer un compte gratuitement',
      ctaBrowse: 'Parcourir les annonces',
      serviceBannerTitle: "Vous n'avez pas le temps de tout mettre en ligne ?",
      serviceBannerDesc: "On vient chez vous, on s'occupe de tout : photos, rédaction, publication.",
      serviceBannerCta: 'En savoir plus',
      blogGuidesTitle: 'Guides du déstockage',
      blogGuidesSubtitle: 'Nos conseils pour vendre, acheter et gérer votre stock professionnel',
      blogGuidesViewAll: 'Tous les guides',
      blogGuidesRead: "Lire l'article",
    },
    nl: {
      heroTitle: 'Destocking tussen professionals',
      heroSlogan: 'Geef uw slapende voorraad een tweede leven — publicatie in 5 minuten.',
      searchPlaceholder: 'Zoek materiaal...',
      searchBtn: 'Zoeken',
      heroRegisterLink: 'Nog niet ingeschreven? Maak gratis een account aan',
      latestListings: 'Laatste advertenties',
      latestSubtitle: 'Recent geplaatst materiaal door onze professionele verkopers',
      viewAll: 'Alles bekijken',
      viewAllListings: 'Bekijk alle advertenties',
      noListingsYet: 'Nog geen advertenties',
      statActiveListings: 'actieve advertenties',
      statVerifiedCompanies: 'geverifieerde bedrijven',
      statSectors: 'gedekte sectoren',
      statNoCommission: 'Geen commissie · Geen abonnement',
      howItWorksTitle: 'Hoe werkt het',
      howItWorksSubtitle: 'DestockPro vergemakkelijkt het contact tussen professionals in 3 eenvoudige stappen.',
      step1Title: 'Plaats uw materiaal',
      step1Desc: "Maak uw advertentie in enkele minuten met foto's, prijs en details.",
      step2Title: 'Vind materiaal',
      step2Desc: 'Zoek tussen de advertenties van professionals en filter op sector.',
      step3Title: 'Handel en sluit af',
      step3Desc: 'Neem contact op met de verkoper, onderhandel en organiseer de transactie.',
      ctaTitle: 'Klaar om te beginnen?',
      ctaText: "Sluit u aan bij DestockPro en begin vandaag nog met het kopen of verkopen van professioneel materiaal in België, Frankrijk, Luxemburg en Nederland.",
      ctaBtn: 'Maak gratis een account aan',
      ctaBrowse: 'Bekijk advertenties',
      serviceBannerTitle: 'Geen tijd om alles online te plaatsen?',
      serviceBannerDesc: "Wij komen bij u langs en regelen alles: foto's, beschrijvingen, publicatie.",
      serviceBannerCta: 'Meer info',
      blogGuidesTitle: 'Destocking-gidsen',
      blogGuidesSubtitle: 'Onze tips om uw professionele voorraad te verkopen, kopen en beheren',
      blogGuidesViewAll: 'Alle gidsen',
      blogGuidesRead: 'Lees het artikel',
    },
  },

  // ─── Service Publication Page ───────────────────────
  servicePublication: {
    fr: {
      heroTitle: "On s'occupe de tout",
      heroDesc: "Vous avez du stock dormant ? On vient chez vous, on fait les photos, on rédige les annonces, on publie. Vous ne faites rien.",
      howTitle: "Comment ça se passe",
      step1Title: "Vous nous contactez", step1Desc: "Via le formulaire ci-dessous",
      step2Title: "On se déplace chez vous", step2Desc: "Partout en Belgique",
      step3Title: "On fait les photos et les annonces", step3Desc: "Photos pro et descriptions optimisées",
      step4Title: "On publie sur DestockPro", step4Desc: "Votre stock commence à rapporter",
      targetTitle: "Pour qui ?",
      targetItem1: "Entreprises avec du stock dormant",
      targetItem2: "Pros qui n'ont pas le temps de gérer leurs annonces",
      targetItem3: "Gros volumes : entrepôts, fins de séries, liquidations",
      pricingTitle: "Combien ça coûte ?",
      pricingDesc: "Sur devis selon le volume. Sans engagement, pas de complications.",
      pricingDelay: "Réponse sous 48h ouvrées.",
      formTitle: "Demander un devis",
      formSubtitle: "Remplissez le formulaire, on revient vers vous sous 48h.",
      fieldName: "Prénom et nom",
      fieldCompany: "Entreprise",
      fieldEmail: "Email",
      fieldPhone: "Téléphone",
      fieldLocation: "Ville ou code postal",
      fieldLocationPlaceholder: "ex: Bruxelles, 1000",
      fieldVolume: "Volume estimé",
      fieldVolumePlaceholder: "ex: environ 30 références, un entrepôt complet, etc.",
      fieldMessage: "Message (optionnel)",
      fieldMessagePlaceholder: "Précisions complémentaires (optionnel)",
      submitBtn: "Envoyer ma demande",
      successToast: "Demande envoyée avec succès !",
      errorToast: "Erreur lors de l'envoi, veuillez réessayer.",
      successTitle: "Demande envoyée !",
      successDesc: "Nous vous répondrons sous 48h ouvrées.",
      backHome: "Retour à l'accueil",
    },
    nl: {
      heroTitle: "Wij regelen alles",
      heroDesc: "Heeft u slapende voorraad? Wij komen bij u langs, maken de foto's, schrijven de advertenties en publiceren alles. U hoeft niets te doen.",
      howTitle: "Hoe gaat het in zijn werk",
      step1Title: "U contacteert ons", step1Desc: "Via het formulier of LinkedIn",
      step2Title: "Wij komen bij u langs", step2Desc: "Overal in Belgie",
      step3Title: "Wij maken foto's en advertenties", step3Desc: "Professionele foto's en geoptimaliseerde beschrijvingen",
      step4Title: "Wij publiceren op DestockPro", step4Desc: "Uw voorraad begint op te brengen",
      targetTitle: "Voor wie?",
      targetItem1: "Bedrijven met slapende voorraad",
      targetItem2: "Professionals die geen tijd hebben om hun advertenties te beheren",
      targetItem3: "Grote volumes: magazijnen, einde reeksen, liquidaties",
      pricingTitle: "Hoeveel kost het?",
      pricingDesc: "Op offerte volgens volume. Geen verplichting, geen complicaties.",
      pricingDelay: "Antwoord binnen 48 werkuren.",
      formTitle: "Offerte aanvragen",
      formSubtitle: "Vul het formulier in, wij nemen binnen 48u contact met u op.",
      fieldName: "Voor- en achternaam",
      fieldCompany: "Bedrijf",
      fieldEmail: "E-mail",
      fieldPhone: "Telefoon",
      fieldLocation: "Stad of postcode",
      fieldLocationPlaceholder: "bv: Brussel, 1000",
      fieldVolume: "Geschat volume",
      fieldVolumePlaceholder: "bv: ongeveer 30 referenties, een volledig magazijn, enz.",
      fieldMessage: "Bericht (optioneel)",
      fieldMessagePlaceholder: "Aanvullende details (optioneel)",
      submitBtn: "Mijn aanvraag versturen",
      successToast: "Aanvraag succesvol verstuurd!",
      errorToast: "Fout bij het versturen, probeer opnieuw.",
      successTitle: "Aanvraag verstuurd!",
      successDesc: "Wij nemen binnen 48 werkuren contact met u op.",
      backHome: "Terug naar startpagina",
    },
  },


  // ─── Login Page ─────────────────────────────────────
  login: {
    fr: {
      title: 'Connexion',
      subtitle: 'Accédez à votre espace professionnel',
      email: 'Email professionnel',
      emailPlaceholder: 'votre@email.com',
      password: 'Mot de passe',
      passwordPlaceholder: 'Votre mot de passe',
      loginBtn: 'Se connecter',
      loggingIn: 'Connexion...',
      noAccount: 'Pas encore de compte ?',
      createAccount: 'Créer un compte',
      fillAll: 'Veuillez remplir tous les champs',
      loginSuccess: 'Connexion réussie',
      loginError: 'Identifiants incorrects',
    },
    nl: {
      title: 'Inloggen',
      subtitle: 'Toegang tot uw professionele ruimte',
      email: 'Professioneel e-mailadres',
      emailPlaceholder: 'uw@email.com',
      password: 'Wachtwoord',
      passwordPlaceholder: 'Uw wachtwoord',
      loginBtn: 'Inloggen',
      loggingIn: 'Inloggen...',
      noAccount: 'Nog geen account?',
      createAccount: 'Account aanmaken',
      fillAll: 'Vul alle velden in',
      loginSuccess: 'Succesvol ingelogd',
      loginError: 'Onjuiste inloggegevens',
    },
  },

  // ─── Register Page ──────────────────────────────────
  register: {
    fr: {
      title: 'Créer un compte',
      subtitle: 'Rejoignez la marketplace du déstockage professionnel',
      benefit1: 'Inscription gratuite, sans engagement',
      benefit2: 'Sans commission sur les ventes',
      benefit3: 'Acheter et vendre du matériel pro',
      benefit4: 'Belgique, France, Luxembourg, Pays-Bas',
      firstName: 'Prénom',
      firstNamePlaceholder: 'Votre prénom',
      lastName: 'Nom',
      lastNamePlaceholder: 'Votre nom',
      email: 'Email',
      emailPlaceholder: 'votre@email.com',
      company: "Nom de l'entreprise",
      companyPlaceholder: 'Nom de votre société',
      password: 'Mot de passe',
      passwordPlaceholder: 'Min. 6 caractères',
      confirmPassword: 'Confirmer',
      confirmPlaceholder: 'Confirmez',
      registerBtn: 'Créer mon compte gratuitement',
      creating: 'Création...',
      legalBefore: 'En créant un compte, vous acceptez les ',
      legalTerms: "Conditions d'utilisation",
      legalAnd: ' et la ',
      legalPrivacy: 'Politique de confidentialité',
      alreadyAccount: 'Déjà un compte ?',
      loginLink: 'Se connecter',
      fillRequired: 'Veuillez remplir tous les champs obligatoires',
      passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      registerSuccess: 'Compte créé avec succès ! Bienvenue sur DestockPro.',
      registerError: "Erreur lors de l'inscription",
    },
    nl: {
      title: 'Account aanmaken',
      subtitle: 'Word lid van de professionele destocking marktplaats',
      benefit1: 'Gratis inschrijving, zonder verplichting',
      benefit2: 'Geen commissie op verkopen',
      benefit3: 'Professioneel materiaal kopen en verkopen',
      benefit4: 'België, Frankrijk, Luxemburg, Nederland',
      firstName: 'Voornaam',
      firstNamePlaceholder: 'Uw voornaam',
      lastName: 'Achternaam',
      lastNamePlaceholder: 'Uw achternaam',
      email: 'E-mail',
      emailPlaceholder: 'uw@email.com',
      company: 'Bedrijfsnaam',
      companyPlaceholder: 'Naam van uw bedrijf',
      password: 'Wachtwoord',
      passwordPlaceholder: 'Min. 6 tekens',
      confirmPassword: 'Bevestigen',
      confirmPlaceholder: 'Bevestig',
      registerBtn: 'Maak mijn account gratis aan',
      creating: 'Aanmaken...',
      legalBefore: 'Door een account aan te maken, gaat u akkoord met de ',
      legalTerms: 'Gebruiksvoorwaarden',
      legalAnd: ' en het ',
      legalPrivacy: 'Privacybeleid',
      alreadyAccount: 'Heeft u al een account?',
      loginLink: 'Inloggen',
      fillRequired: 'Vul alle verplichte velden in',
      passwordMinLength: 'Het wachtwoord moet minimaal 6 tekens bevatten',
      passwordMismatch: 'Wachtwoorden komen niet overeen',
      registerSuccess: 'Account succesvol aangemaakt! Welkom bij DestockPro.',
      registerError: 'Fout bij registratie',
    },
  },

  // ─── Listings / Search Page ─────────────────────────
  listings: {
    fr: {
      searchPlaceholder: 'Rechercher du matériel...',
      filters: 'Filtres',
      sector: 'Secteur',
      category: 'Catégorie',
      condition: 'État',
      allSectors: 'Tous les secteurs',
      allCategories: 'Toutes les catégories',
      allConditions: 'Tous les états',
      clearFilters: 'Effacer les filtres',
      resultsCount: '{count} résultat{s} trouvé{s}',
      noResults: 'Aucune annonce trouvée',
      noResultsSub: 'Essayez de modifier vos critères de recherche',
      sortNewest: 'Plus récentes',
      sortOldest: 'Plus anciennes',
      sortPriceAsc: 'Prix croissant',
      sortPriceDesc: 'Prix décroissant',
      sellerListingsOf: 'Annonces de',
      viewAllListings: 'Voir toutes les annonces',
      result: 'résultat',
      results: 'résultats',
      readAlso: 'À lire',
      readAlsoCta: "Lire l'article",
    },
    nl: {
      searchPlaceholder: 'Zoek materiaal...',
      filters: 'Filters',
      sector: 'Sector',
      category: 'Categorie',
      condition: 'Staat',
      allSectors: 'Alle sectoren',
      allCategories: 'Alle categorieën',
      allConditions: 'Alle toestanden',
      clearFilters: 'Filters wissen',
      resultsCount: '{count} resultaat/resultaten gevonden',
      noResults: 'Geen advertenties gevonden',
      noResultsSub: 'Probeer uw zoekcriteria aan te passen',
      sortNewest: 'Nieuwste',
      sortOldest: 'Oudste',
      sortPriceAsc: 'Prijs oplopend',
      sortPriceDesc: 'Prijs aflopend',
      sellerListingsOf: 'Advertenties van',
      viewAllListings: 'Bekijk alle advertenties',
      result: 'resultaat',
      results: 'resultaten',
      readAlso: 'Te lezen',
      readAlsoCta: 'Lees het artikel',
    },
  },

  // ─── Conditions ─────────────────────────────────────
  conditions: {
    fr: { neuf: 'Neuf', occasion: 'Occasion', reconditionne: 'Reconditionné' },
    nl: { neuf: 'Nieuw', occasion: 'Tweedehands', reconditionne: 'Gereviseerd' },
  },

  // ─── Sectors ────────────────────────────────────────
  sectors: {
    fr: {
      piscine: 'Piscine', hvac: 'HVAC / Chauffage / Climatisation', plomberie: 'Plomberie',
      construction: 'Construction', electricite: 'Électricité',
      jardinage: 'Jardinage / Espaces verts', outillage: 'Outillage professionnel', autre: 'Autre',
    },
    nl: {
      piscine: 'Zwembad', hvac: 'HVAC / Verwarming / Airco', plomberie: 'Loodgieterij',
      construction: 'Bouw', electricite: 'Elektriciteit',
      jardinage: 'Tuinieren / Groenvoorziening', outillage: 'Professioneel gereedschap', autre: 'Overige',
    },
  },

  // ─── Categories (per sector) ────────────────────────
  categories: {
    fr: {
      // Piscine
      'Pompes': 'Pompes', 'Filtres': 'Filtres', "Traitement de l'eau": "Traitement de l'eau",
      'Chauffage piscine': 'Chauffage piscine', 'Nettoyage': 'Nettoyage',
      'Couvertures et volets': 'Couvertures et volets', 'Éclairage piscine': 'Éclairage piscine',
      'Pièces à sceller': 'Pièces à sceller', 'Hydraulique / PVC': 'Hydraulique / PVC',
      'Construction piscine': 'Construction piscine', 'Revêtements': 'Revêtements',
      'Équipements techniques': 'Équipements techniques',
      // HVAC
      'Chauffage': 'Chauffage', 'Climatisation': 'Climatisation', 'Ventilation': 'Ventilation',
      'Régulation': 'Régulation', 'Conduits et gaines': 'Conduits et gaines',
      // Plomberie
      'Robinetterie': 'Robinetterie', 'Tuyauterie': 'Tuyauterie', 'Sanitaires': 'Sanitaires',
      'Évacuation': 'Évacuation', 'Chauffe-eau': 'Chauffe-eau', 'Adoucisseurs': 'Adoucisseurs',
      'Outillage plomberie': 'Outillage plomberie',
      // Construction
      'Gros œuvre': 'Gros œuvre', 'Second œuvre': 'Second œuvre', 'Outillage': 'Outillage',
      'Matériaux': 'Matériaux', 'Isolation': 'Isolation', 'Toiture': 'Toiture',
      'Échafaudages': 'Échafaudages', 'Menuiserie': 'Menuiserie',
      'Béton et ciment': 'Béton et ciment', 'Terrassement': 'Terrassement',
      // Électricité
      'Câblage': 'Câblage', 'Appareillage': 'Appareillage', 'Éclairage': 'Éclairage',
      'Domotique': 'Domotique', 'Tableaux électriques': 'Tableaux électriques',
      'Panneaux solaires': 'Panneaux solaires', 'Bornes de recharge': 'Bornes de recharge',
      'Outillage électrique': 'Outillage électrique',
      // Jardinage
      'Tondeuses': 'Tondeuses', 'Taille-haies': 'Taille-haies', 'Arrosage': 'Arrosage',
      'Outillage jardin': 'Outillage jardin', 'Serres': 'Serres', 'Clôtures': 'Clôtures',
      // Outillage pro
      'Outillage électroportatif': 'Outillage électroportatif', 'Outillage à main': 'Outillage à main',
      'Compresseurs': 'Compresseurs', 'Groupes électrogènes': 'Groupes électrogènes',
      'Postes à souder': 'Postes à souder', 'Échelles et escabeaux': 'Échelles et escabeaux',
      'Levage et manutention': 'Levage et manutention', 'Mesure et traçage': 'Mesure et traçage',
      // Autre
      'Mobilier professionnel': 'Mobilier professionnel', 'Stockage et rayonnage': 'Stockage et rayonnage',
      'Sécurité': 'Sécurité', 'Nettoyage professionnel': 'Nettoyage professionnel',
      'Transport': 'Transport', 'Divers': 'Divers',
      // Communs
      'Accessoires': 'Accessoires', 'Pièces détachées': 'Pièces détachées', 'Autre': 'Autre',
    },
    nl: {
      // Piscine
      'Pompes': 'Pompen', 'Filtres': 'Filters', "Traitement de l'eau": 'Waterbehandeling',
      'Chauffage piscine': 'Zwembadverwarming', 'Nettoyage': 'Reiniging',
      'Couvertures et volets': 'Afdekking en rolluiken', 'Éclairage piscine': 'Zwembadverlichting',
      'Pièces à sceller': 'Inbouwstukken', 'Hydraulique / PVC': 'Hydrauliek / PVC',
      'Construction piscine': 'Zwembadbouw', 'Revêtements': 'Bekleding',
      'Équipements techniques': 'Technische uitrusting',
      // HVAC
      'Chauffage': 'Verwarming', 'Climatisation': 'Airconditioning', 'Ventilation': 'Ventilatie',
      'Régulation': 'Regeling', 'Conduits et gaines': 'Leidingen en kanalen',
      // Plomberie
      'Robinetterie': 'Kranen', 'Tuyauterie': 'Leidingwerk', 'Sanitaires': 'Sanitair',
      'Évacuation': 'Afvoer', 'Chauffe-eau': 'Boilers', 'Adoucisseurs': 'Waterontharders',
      'Outillage plomberie': 'Loodgietersgereedschap',
      // Construction
      'Gros œuvre': 'Ruwbouw', 'Second œuvre': 'Afwerking', 'Outillage': 'Gereedschap',
      'Matériaux': 'Materialen', 'Isolation': 'Isolatie', 'Toiture': 'Dakwerken',
      'Échafaudages': 'Steigers', 'Menuiserie': 'Schrijnwerk',
      'Béton et ciment': 'Beton en cement', 'Terrassement': 'Grondwerken',
      // Électricité
      'Câblage': 'Bekabeling', 'Appareillage': 'Schakelmateriaal', 'Éclairage': 'Verlichting',
      'Domotique': 'Domotica', 'Tableaux électriques': 'Elektrische panelen',
      'Panneaux solaires': 'Zonnepanelen', 'Bornes de recharge': 'Laadpalen',
      'Outillage électrique': 'Elektrisch gereedschap',
      // Jardinage
      'Tondeuses': 'Grasmaaiers', 'Taille-haies': 'Heggenscharen', 'Arrosage': 'Bewatering',
      'Outillage jardin': 'Tuingereedschap', 'Serres': 'Serres', 'Clôtures': 'Omheiningen',
      // Outillage pro
      'Outillage électroportatif': 'Elektrisch handgereedschap', 'Outillage à main': 'Handgereedschap',
      'Compresseurs': 'Compressoren', 'Groupes électrogènes': 'Stroomgeneratoren',
      'Postes à souder': 'Lasapparaten', 'Échelles et escabeaux': 'Ladders en trappen',
      'Levage et manutention': 'Hef- en transportmiddelen', 'Mesure et traçage': 'Meet- en markeringsgereedschap',
      // Autre
      'Mobilier professionnel': 'Professioneel meubilair', 'Stockage et rayonnage': 'Opslag en rekken',
      'Sécurité': 'Beveiliging', 'Nettoyage professionnel': 'Professionele reiniging',
      'Transport': 'Transport', 'Divers': 'Diversen',
      // Communs
      'Accessoires': 'Accessoires', 'Pièces détachées': 'Reserveonderdelen', 'Autre': 'Overige',
    },
  },

  // ─── Dashboard ──────────────────────────────────────
  dashboard: {
    fr: {
      title: 'Tableau de bord',
      welcome: 'Bienvenue,',
      publishAd: 'Publier une annonce',
      myListings: 'Mes annonces',
      profile: 'Profil',
      verification: 'Vérification',
      noListings: 'Aucune annonce publiée',
      firstListing: 'Publier ma première annonce',
      deleteConfirm: 'Supprimer cette annonce ?',
      deleted: 'Annonce supprimée',
      deleteError: 'Erreur lors de la suppression',
      deleteTitle: "Supprimer l'annonce",
      deleteReasonSold: 'Vendu via DestockPro',
      deleteReasonElsewhere: 'Vendu en dehors de DestockPro',
      deleteReasonUnavailable: 'Plus disponible / retiré du stock',
      deleteReasonOther: 'Autre raison',
      deleteReasonDetailPlaceholder: 'Préciser la raison...',
      deleteCancel: 'Annuler',
      deleteConfirmBtn: 'Supprimer',
      deleteDeleting: 'Suppression...',
      profileUpdated: 'Profil mis à jour',
      profileError: 'Erreur lors de la mise à jour',
      saveChanges: 'Enregistrer les modifications',
      saving: 'Enregistrement...',
      company: 'Entreprise',
      phone: 'Téléphone',
      companyEmail: 'Email entreprise',
      firstName: 'Prénom',
      lastName: 'Nom',
      companyName: "Nom de l'entreprise",
      role: 'Rôle',
      administrator: 'Administrateur',
      boosted: 'Boosté',
      homepage: 'Accueil',
      favorites: 'Favoris',
      noFavorites: 'Vous n\'avez aucune annonce sauvegardée',
      browseListing: 'Parcourir les annonces',
    },
    nl: {
      title: 'Dashboard',
      welcome: 'Welkom,',
      publishAd: 'Advertentie plaatsen',
      myListings: 'Mijn advertenties',
      profile: 'Profiel',
      verification: 'Verificatie',
      noListings: 'Geen advertenties geplaatst',
      firstListing: 'Mijn eerste advertentie plaatsen',
      deleteConfirm: 'Deze advertentie verwijderen?',
      deleted: 'Advertentie verwijderd',
      deleteError: 'Fout bij verwijderen',
      deleteTitle: 'Advertentie verwijderen',
      deleteReasonSold: 'Verkocht via DestockPro',
      deleteReasonElsewhere: 'Verkocht buiten DestockPro',
      deleteReasonUnavailable: 'Niet meer beschikbaar / uit voorraad',
      deleteReasonOther: 'Andere reden',
      deleteReasonDetailPlaceholder: 'Geef de reden op...',
      deleteCancel: 'Annuleren',
      deleteConfirmBtn: 'Verwijderen',
      deleteDeleting: 'Verwijderen...',
      profileUpdated: 'Profiel bijgewerkt',
      profileError: 'Fout bij bijwerken',
      saveChanges: 'Wijzigingen opslaan',
      saving: 'Opslaan...',
      company: 'Bedrijf',
      phone: 'Telefoon',
      companyEmail: 'Bedrijfs-e-mail',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      companyName: 'Bedrijfsnaam',
      role: 'Rol',
      administrator: 'Beheerder',
      boosted: 'Geboost',
      homepage: 'Startpagina',
      favorites: 'Favorieten',
      noFavorites: 'U heeft geen opgeslagen advertenties',
      browseListing: 'Advertenties bekijken',
    },
  },

  // ─── Verification ───────────────────────────────────
  verification: {
    fr: {
      verifyTitle: 'Vérifier mon entreprise',
      verifyDesc: 'Obtenez le badge "Entreprise vérifiée" et renforcez la confiance auprès des acheteurs.',
      companyName: "Nom de l'entreprise",
      vatNumber: 'Numéro de TVA',
      companyAddress: "Adresse de l'entreprise",
      country: 'Pays',
      submitBtn: 'Soumettre ma demande de vérification',
      submitting: 'Soumission...',
      verifiedTitle: 'Entreprise vérifiée',
      verifiedDesc: 'Votre entreprise est vérifiée. Le badge "Entreprise vérifiée" est affiché sur votre profil et vos annonces.',
      pendingTitle: "Demande en cours d'examen",
      pendingDesc: 'Votre demande de vérification est en cours de traitement. Vous serez notifié par email une fois la décision prise.',
      rejectedTitle: 'Vérification non approuvée',
      rejectedDesc: "Votre demande de vérification n'a pas été approuvée. Vous pouvez soumettre une nouvelle demande ci-dessous.",
      comment: 'Commentaire',
      submittedInfo: 'Informations soumises',
      verifiedInfo: 'Informations vérifiées',
      submittedOn: 'Soumise le',
      fillRequired: 'Veuillez remplir tous les champs obligatoires',
      submitted: 'Demande de vérification envoyée !',
      errorSubmit: 'Erreur lors de la soumission',
    },
    nl: {
      verifyTitle: 'Mijn bedrijf verifiëren',
      verifyDesc: 'Verkrijg het badge "Geverifieerd bedrijf" en versterk het vertrouwen bij kopers.',
      companyName: 'Bedrijfsnaam',
      vatNumber: 'BTW-nummer',
      companyAddress: 'Bedrijfsadres',
      country: 'Land',
      submitBtn: 'Verificatieverzoek indienen',
      submitting: 'Indienen...',
      verifiedTitle: 'Geverifieerd bedrijf',
      verifiedDesc: 'Uw bedrijf is geverifieerd. Het badge "Geverifieerd bedrijf" wordt weergegeven op uw profiel en advertenties.',
      pendingTitle: 'Aanvraag in behandeling',
      pendingDesc: 'Uw verificatieverzoek wordt verwerkt. U wordt per e-mail op de hoogte gebracht zodra er een beslissing is genomen.',
      rejectedTitle: 'Verificatie niet goedgekeurd',
      rejectedDesc: 'Uw verificatieverzoek is niet goedgekeurd. U kunt hieronder een nieuw verzoek indienen.',
      comment: 'Opmerking',
      submittedInfo: 'Ingediende informatie',
      verifiedInfo: 'Geverifieerde informatie',
      submittedOn: 'Ingediend op',
      fillRequired: 'Vul alle verplichte velden in',
      submitted: 'Verificatieverzoek verzonden!',
      errorSubmit: 'Fout bij indienen',
    },
  },

  // ─── Create Listing ─────────────────────────────────
  createListing: {
    fr: {
      title: 'Publier une annonce',
      limitReached: 'Limite atteinte',
      limitMsg: "Vous avez atteint la limite de 2 annonces pour les comptes non vérifiés.\nPour publier plus d'annonces, veuillez vérifier votre entreprise.",
      verifyCompany: 'Vérifier mon entreprise',
      limitInfo: '{count}/2 annonces utilisées — Les comptes non vérifiés sont limités à 2 annonces.',
      verify: 'Vérifier',
      generalInfo: 'Informations générales',
      adTitle: "Titre de l'annonce",
      adTitleHelp: "Indiquez la marque, le modèle et la référence : c'est ce que les acheteurs tapent dans Google. Exemple : Pompe à chaleur Carrier 61AF 035",
      description: 'Description',
      descPlaceholder: 'Décrivez votre matériel...',
      price: 'Prix unitaire (€) HTVA',
      quantity: 'Quantité',
      condition: 'État',
      classification: 'Classification',
      sector: 'Secteur',
      sectorPlaceholder: 'Choisir un secteur',
      categoryLabel: 'Catégorie',
      categoryPlaceholder: 'Choisir une catégorie',
      brand: 'Marque',
      reference: 'Référence produit',
      location: 'Localisation',
      locationPlaceholder: 'Ex: Bruxelles, Belgique',
      locationOptions: 'Localisation & Options',
      deliveryAvailable: 'Livraison possible',
      pickupOnSite: 'Retrait sur place',
      invoiceAvailable: 'Facture disponible',
      warrantyLabel: 'Garantie',
      photos: 'Photos',
      photosSubtitle: "Ajoutez jusqu'à 6 photos de votre matériel",
      publishBtn: "Publier l'annonce",
      publishing: 'Publication...',
      publishSuccess: 'Annonce publiée avec succès',
      publishError: "Erreur lors de la publication",
      fillRequired: 'Veuillez remplir tous les champs obligatoires',
      loginRequired: 'Vous devez être connecté pour publier une annonce.',
      createAccountBtn: 'Créer un compte',
      conditionOptional: '-- Optionnel --',
      conditionTooltipTitle: 'Quelle est la différence ?',
      conditionNeuf: 'Produit neuf, encore dans son emballage d\'origine',
      conditionOccasion: 'Produit déballé, stocké ou déjà utilisé',
      conditionReconditionne: 'Produit remis à neuf par un professionnel',
      conditionPlaceholder: "Décrivez l'état du produit",
      conditionTooltipExamples: "Exemples d'états :",
      conditionEx1: 'Neuf sous emballage',
      conditionEx2: 'Neuf déballé, jamais utilisé',
      conditionEx3: 'Stock dormant, excellent état',
      conditionEx4: 'Occasion, bon état général',
      conditionEx5: "Léger défaut d'emballage",
      conditionEx6: 'Reconditionné par un professionnel',
    },
    nl: {
      title: 'Advertentie plaatsen',
      limitReached: 'Limiet bereikt',
      limitMsg: "U heeft de limiet van 2 advertenties voor niet-geverifieerde accounts bereikt.\nOm meer advertenties te plaatsen, verifieer uw bedrijf.",
      verifyCompany: 'Mijn bedrijf verifiëren',
      limitInfo: '{count}/2 advertenties gebruikt — Niet-geverifieerde accounts zijn beperkt tot 2 advertenties.',
      verify: 'Verifiëren',
      generalInfo: 'Algemene informatie',
      adTitle: 'Advertentietitel',
      adTitleHelp: 'Vermeld het merk, het model en de referentie: dat is wat kopers in Google typen. Voorbeeld: Warmtepomp Carrier 61AF 035',
      description: 'Beschrijving',
      descPlaceholder: 'Beschrijf uw materiaal...',
      price: 'Eenheidsprijs (€) BTW excl.',
      quantity: 'Aantal',
      condition: 'Staat',
      classification: 'Classificatie',
      sector: 'Sector',
      sectorPlaceholder: 'Kies een sector',
      categoryLabel: 'Categorie',
      categoryPlaceholder: 'Kies een categorie',
      brand: 'Merk',
      reference: 'Productreferentie',
      location: 'Locatie',
      locationPlaceholder: 'Bv: Brussel, België',
      locationOptions: 'Locatie & Opties',
      deliveryAvailable: 'Levering mogelijk',
      pickupOnSite: 'Afhalen ter plaatse',
      invoiceAvailable: 'Factuur beschikbaar',
      warrantyLabel: 'Garantie',
      photos: "Foto's",
      photosSubtitle: "Voeg tot 6 foto's van uw materiaal toe",
      publishBtn: 'Advertentie plaatsen',
      publishing: 'Plaatsen...',
      publishSuccess: 'Advertentie succesvol geplaatst',
      publishError: 'Fout bij het plaatsen',
      fillRequired: 'Vul alle verplichte velden in',
      loginRequired: 'U moet ingelogd zijn om een advertentie te plaatsen.',
      createAccountBtn: 'Account aanmaken',
      conditionOptional: '-- Optioneel --',
      conditionTooltipTitle: 'Wat is het verschil?',
      conditionNeuf: 'Nieuw product, nog in originele verpakking',
      conditionOccasion: 'Uitgepakt, opgeslagen of eerder gebruikt product',
      conditionReconditionne: 'Professioneel opgeknapt product',
      conditionPlaceholder: 'Beschrijf de staat van het product',
      conditionTooltipExamples: 'Voorbeelden van staten:',
      conditionEx1: 'Nieuw in verpakking',
      conditionEx2: 'Nieuw uitgepakt, nooit gebruikt',
      conditionEx3: 'Slapende voorraad, uitstekende staat',
      conditionEx4: 'Gebruikt, goede algemene staat',
      conditionEx5: 'Licht beschadigde verpakking',
      conditionEx6: 'Professioneel gereviseerd',
    },
  },

  // ─── Edit Listing ───────────────────────────────────
  editListing: {
    fr: {
      title: "Modifier l'annonce",
      backToDashboard: 'Retour au tableau de bord',
      generalInfo: 'Informations générales',
      adTitle: "Titre de l'annonce",
      adTitleHelp: "Indiquez la marque, le modèle et la référence : c'est ce que les acheteurs tapent dans Google. Exemple : Pompe à chaleur Carrier 61AF 035",
      description: 'Description',
      descPlaceholder: 'Décrivez votre matériel...',
      price: 'Prix unitaire (€) HTVA',
      quantity: 'Quantité',
      condition: 'État',
      classification: 'Classification',
      sector: 'Secteur',
      sectorPlaceholder: 'Choisir un secteur',
      categoryLabel: 'Catégorie',
      categoryPlaceholder: 'Choisir une catégorie',
      brand: 'Marque',
      reference: 'Référence produit',
      photos: 'Photos',
      photosSubtitle: 'Gérez les photos de votre annonce (max 6)',
      location: 'Localisation',
      locationPlaceholder: 'Ex: Bruxelles, Belgique',
      locationOptions: 'Localisation & Options',
      deliveryAvailable: 'Livraison possible',
      pickupOnSite: 'Retrait sur place',
      invoiceAvailable: 'Facture disponible',
      warrantyLabel: 'Garantie',
      saveBtn: 'Enregistrer les modifications',
      saving: 'Enregistrement...',
      saveSuccess: 'Annonce modifiée avec succès',
      saveError: 'Erreur lors de la modification',
      fillRequired: 'Veuillez remplir tous les champs obligatoires',
      notFound: 'Annonce introuvable',
      conditionOptional: '-- Optionnel --',
      conditionTooltipTitle: 'Quelle est la différence ?',
      conditionNeuf: 'Produit neuf, encore dans son emballage d\'origine',
      conditionOccasion: 'Produit déballé, stocké ou déjà utilisé',
      conditionReconditionne: 'Produit remis à neuf par un professionnel',
      conditionPlaceholder: "Décrivez l'état du produit",
      conditionTooltipExamples: "Exemples d'états :",
      conditionEx1: 'Neuf sous emballage',
      conditionEx2: 'Neuf déballé, jamais utilisé',
      conditionEx3: 'Stock dormant, excellent état',
      conditionEx4: 'Occasion, bon état général',
      conditionEx5: "Léger défaut d'emballage",
      conditionEx6: 'Reconditionné par un professionnel',
      deleteListing: 'Supprimer cette annonce',
      deleteTitle: "Supprimer l'annonce",
      deleteReasonSold: 'Vendu via DestockPro',
      deleteReasonElsewhere: 'Vendu en dehors de DestockPro',
      deleteReasonUnavailable: 'Plus disponible / retiré du stock',
      deleteReasonOther: 'Autre raison',
      deleteReasonDetailPlaceholder: 'Préciser la raison...',
      deleteCancel: 'Annuler',
      deleteConfirmBtn: 'Supprimer',
      deleteDeleting: 'Suppression...',
    },
    nl: {
      title: 'Advertentie bewerken',
      backToDashboard: 'Terug naar dashboard',
      generalInfo: 'Algemene informatie',
      adTitle: 'Advertentietitel',
      adTitleHelp: 'Vermeld het merk, het model en de referentie: dat is wat kopers in Google typen. Voorbeeld: Warmtepomp Carrier 61AF 035',
      description: 'Beschrijving',
      descPlaceholder: 'Beschrijf uw materiaal...',
      price: 'Eenheidsprijs (€) BTW excl.',
      quantity: 'Aantal',
      condition: 'Staat',
      classification: 'Classificatie',
      sector: 'Sector',
      sectorPlaceholder: 'Kies een sector',
      categoryLabel: 'Categorie',
      categoryPlaceholder: 'Kies een categorie',
      brand: 'Merk',
      reference: 'Productreferentie',
      photos: "Foto's",
      photosSubtitle: "Beheer de foto's van uw advertentie (max 6)",
      location: 'Locatie',
      locationPlaceholder: 'Bv: Brussel, België',
      locationOptions: 'Locatie & Opties',
      deliveryAvailable: 'Levering mogelijk',
      pickupOnSite: 'Afhalen ter plaatse',
      invoiceAvailable: 'Factuur beschikbaar',
      warrantyLabel: 'Garantie',
      saveBtn: 'Wijzigingen opslaan',
      saving: 'Opslaan...',
      saveSuccess: 'Advertentie succesvol bijgewerkt',
      saveError: 'Fout bij het bijwerken',
      fillRequired: 'Vul alle verplichte velden in',
      notFound: 'Advertentie niet gevonden',
      conditionOptional: '-- Optioneel --',
      conditionTooltipTitle: 'Wat is het verschil?',
      conditionNeuf: 'Nieuw product, nog in originele verpakking',
      conditionOccasion: 'Uitgepakt, opgeslagen of eerder gebruikt product',
      conditionReconditionne: 'Professioneel opgeknapt product',
      conditionPlaceholder: 'Beschrijf de staat van het product',
      conditionTooltipExamples: 'Voorbeelden van staten:',
      conditionEx1: 'Nieuw in verpakking',
      conditionEx2: 'Nieuw uitgepakt, nooit gebruikt',
      conditionEx3: 'Slapende voorraad, uitstekende staat',
      conditionEx4: 'Gebruikt, goede algemene staat',
      conditionEx5: 'Licht beschadigde verpakking',
      conditionEx6: 'Professioneel gereviseerd',
      deleteListing: 'Deze advertentie verwijderen',
      deleteTitle: 'Advertentie verwijderen',
      deleteReasonSold: 'Verkocht via DestockPro',
      deleteReasonElsewhere: 'Verkocht buiten DestockPro',
      deleteReasonUnavailable: 'Niet meer beschikbaar / uit voorraad',
      deleteReasonOther: 'Andere reden',
      deleteReasonDetailPlaceholder: 'Geef de reden op...',
      deleteCancel: 'Annuleren',
      deleteConfirmBtn: 'Verwijderen',
      deleteDeleting: 'Verwijderen...',
    },
  },

  // ─── Listing Detail ─────────────────────────────────
  listingDetail: {
    fr: {
      contactSeller: 'Contacter le vendeur',
      boostListing: 'Booster cette annonce',
      description: 'Description',
      details: 'Caractéristiques',
      condition: 'État',
      brand: 'Marque',
      reference: 'Référence',
      model: 'Modèle',
      quantity: 'Quantité',
      sector: 'Secteur',
      category: 'Catégorie',
      views: 'vues',
      publishedOn: 'Publié le',
      onlineStatus: 'En ligne',
      notFound: 'Annonce introuvable',
      notFoundError: 'Annonce introuvable',
      backToListings: 'Retour aux annonces',
      selfContact: 'Vous ne pouvez pas vous contacter vous-même',
      conversationError: 'Erreur lors de la création de la conversation',
      saved: 'Sauvegardée',
      save: 'Sauvegarder',
      savedToast: 'Annonce sauvegardée',
      removedToast: 'Annonce retirée des favoris',
      otherSellerListings: 'Autres annonces de',
      viewSellerListings: 'Voir les autres annonces du vendeur',
      viewAllSellerListings: 'Voir toutes les annonces du vendeur',
      otherListingsCount: 'Voir les {count} autre(s) annonce(s) du vendeur',
      seller: 'Vendeur',
      loginToContact: 'Connectez-vous pour contacter',
      makeOffer: 'Faire une offre',
      offerSubtitle: 'Prix demandé :',
      offerPlaceholder: 'Votre offre',
      sendOffer: 'Envoyer l\'offre',
      offerMessage: 'Bonjour, je souhaite faire une offre de {price} pour "{title}". Est-ce que cela vous conviendrait ?',
    },
    nl: {
      contactSeller: 'Verkoper contacteren',
      boostListing: 'Advertentie boosten',
      description: 'Beschrijving',
      details: 'Kenmerken',
      condition: 'Staat',
      brand: 'Merk',
      reference: 'Referentie',
      model: 'Model',
      quantity: 'Aantal',
      sector: 'Sector',
      category: 'Categorie',
      views: 'weergaven',
      publishedOn: 'Gepubliceerd op',
      onlineStatus: 'Online',
      notFound: 'Advertentie niet gevonden',
      notFoundError: 'Advertentie niet gevonden',
      backToListings: 'Terug naar advertenties',
      selfContact: 'U kunt geen contact opnemen met uzelf',
      conversationError: 'Fout bij het aanmaken van het gesprek',
      saved: 'Opgeslagen',
      save: 'Opslaan',
      savedToast: 'Advertentie opgeslagen',
      removedToast: 'Advertentie verwijderd uit favorieten',
      otherSellerListings: 'Andere advertenties van',
      viewSellerListings: 'Bekijk de andere advertenties van de verkoper',
      viewAllSellerListings: 'Bekijk alle advertenties van de verkoper',
      otherListingsCount: 'Bekijk de {count} andere advertentie(s) van de verkoper',
      seller: 'Verkoper',
      loginToContact: 'Log in om contact op te nemen',
      makeOffer: 'Bod uitbrengen',
      offerSubtitle: 'Gevraagde prijs:',
      offerPlaceholder: 'Uw bod',
      sendOffer: 'Bod versturen',
      offerMessage: 'Hallo, ik wil graag een bod uitbrengen van {price} voor "{title}". Zou dat voor u aanvaardbaar zijn?',
    },
  },

  // ─── Messages ───────────────────────────────────────
  messages: {
    fr: {
      title: 'Messages',
      conversations: 'Conversations',
      noConversations: 'Aucune conversation',
      selectConversation: 'Sélectionnez une conversation',
      selectConversationSub: 'Choisissez une conversation pour commencer',
      messagePlaceholder: 'Votre message...',
      sendError: "Erreur lors de l'envoi",
      today: "Aujourd'hui",
      yesterday: 'Hier',
      ad: 'Annonce',
      newConversation: 'Nouvelle conversation',
      searchPlaceholder: 'Rechercher une conversation...',
      online: 'En ligne',
      noResults: 'Aucun résultat',
      delete: 'Supprimer',
      deleteConfirm: 'Supprimer cette conversation ?',
      deleted: 'Conversation supprimée',
      archive: 'Archiver',
      archived: 'Conversation archivée',
      unarchive: 'Désarchiver',
      unarchived: 'Conversation désarchivée',
      archivedTab: 'Archivées',
      block: 'Bloquer',
      blocked: 'Utilisateur bloqué',
      unblock: 'Débloquer',
      unblocked: 'Utilisateur débloqué',
      blockedMessage: 'Conversation bloquée',
      sendImage: 'Envoyer une image',
      imageUploading: 'Envoi en cours...',
      report: 'Signaler',
      reportReason: 'Raison du signalement :',
      reported: 'Conversation signalée',
    },
    nl: {
      title: 'Berichten',
      conversations: 'Gesprekken',
      noConversations: 'Geen gesprekken',
      selectConversation: 'Selecteer een gesprek',
      selectConversationSub: 'Kies een gesprek om te beginnen',
      messagePlaceholder: 'Uw bericht...',
      sendError: 'Fout bij verzenden',
      today: 'Vandaag',
      yesterday: 'Gisteren',
      ad: 'Advertentie',
      newConversation: 'Nieuw gesprek',
      searchPlaceholder: 'Zoek een gesprek...',
      online: 'Online',
      noResults: 'Geen resultaten',
      delete: 'Verwijderen',
      deleteConfirm: 'Dit gesprek verwijderen?',
      deleted: 'Gesprek verwijderd',
      archive: 'Archiveren',
      archived: 'Gesprek gearchiveerd',
      unarchive: 'Dearchiveren',
      unarchived: 'Gesprek gedearchiveerd',
      archivedTab: 'Gearchiveerd',
      block: 'Blokkeren',
      blocked: 'Gebruiker geblokkeerd',
      unblock: 'Deblokkeren',
      unblocked: 'Gebruiker gedeblokkeerd',
      blockedMessage: 'Gesprek geblokkeerd',
      sendImage: 'Afbeelding verzenden',
      imageUploading: 'Uploaden...',
      report: 'Melden',
      reportReason: 'Reden van melding:',
      reported: 'Gesprek gemeld',
    },
  },

  // ─── Contact Page ───────────────────────────────────
  contact: {
    fr: {
      title: 'Contact',
      subtitle: "Une question ? N'hésitez pas à nous écrire",
      formSubtitle: 'Remplissez le formulaire ci-dessous, nous vous répondrons dans les plus brefs délais.',
      name: 'Nom complet',
      namePlaceholder: 'Votre nom',
      email: 'Email',
      emailPlaceholder: 'votre@email.com',
      subject: 'Sujet',
      subjectPlaceholder: 'Sujet de votre message',
      message: 'Message',
      messagePlaceholder: 'Votre message...',
      sendBtn: 'Envoyer le message',
      sending: 'Envoi...',
      sent: 'Message envoyé avec succès',
      sendError: "Erreur lors de l'envoi",
      fillAll: 'Veuillez remplir tous les champs',
    },
    nl: {
      title: 'Contact',
      subtitle: 'Een vraag? Neem gerust contact met ons op',
      formSubtitle: 'Vul het onderstaande formulier in, we nemen zo snel mogelijk contact met u op.',
      name: 'Volledige naam',
      namePlaceholder: 'Uw naam',
      email: 'E-mail',
      emailPlaceholder: 'uw@email.com',
      subject: 'Onderwerp',
      subjectPlaceholder: 'Onderwerp van uw bericht',
      message: 'Bericht',
      messagePlaceholder: 'Uw bericht...',
      sendBtn: 'Bericht verzenden',
      sending: 'Verzenden...',
      sent: 'Bericht succesvol verzonden!',
      sendError: 'Fout bij verzenden',
      fillAll: 'Vul alle velden in',
    },
  },

  // ─── About Page ─────────────────────────────────────
  about: {
    fr: {
      title: 'À propos de DestockPro',
      missionTitle: 'Notre mission',
      missionText: "Notre mission est de donner une seconde vie au matériel professionnel inutilisé. En connectant les entreprises entre elles, nous aidons à valoriser le stock dormant, réduire le gaspillage et rendre du matériel de qualité plus accessible.",
      whyTitle: 'Pourquoi DestockPro ?',
      whyText: "DestockPro est né d'un constat simple : des milliers d'entreprises en Belgique, France, Luxembourg et Pays-Bas disposent de matériel professionnel inutilisé — stock dormant, surstock, fins de série — tandis que d'autres recherchent exactement ce type de matériel à prix réduit.",
      trustTitle: 'Pourquoi nous faire confiance',
      trustText: "DestockPro a été conçu pour offrir un environnement fiable et transparent aux professionnels. Chaque détail de la plateforme est pensé pour garantir des échanges sereins et efficaces.",
      belgianPlatform: 'Plateforme européenne, pensée pour les professionnels',
      belgianDesc: "DestockPro est une initiative belge qui place la confiance et la simplicité au cœur de chaque échange entre entreprises en Belgique, France, Luxembourg et Pays-Bas.",
      stockVal: 'Valorisation du stock', stockValDesc: 'Transformez votre stock dormant en opportunité commerciale.',
      circular: 'Économie circulaire', circularDesc: 'Participez à une démarche responsable et durable.',
      network: 'Réseau B2B', networkDesc: "Connectez-vous avec d'autres professionnels de confiance.",
      prices: 'Prix compétitifs', pricesDesc: 'Accédez à du matériel de qualité à prix réduit.',
      multiSector: 'Multi-secteurs', multiSectorDesc: 'Piscine, HVAC, construction, électricité et plus.',
      trust: 'Confiance', trustDesc: 'Profils vérifiés et transactions sécurisées.',
      verifiedProfiles: 'Profils professionnels vérifiés', verifiedProfilesDesc: "Chaque utilisateur renseigne ses informations d'entreprise (nom, TVA, adresse). Vous savez toujours avec qui vous échangez.",
      dataProtected: 'Données protégées (RGPD)', dataProtectedDesc: "Vos données sont hébergées en toute sécurité et ne sont jamais revendues. Nous respectons strictement la réglementation européenne.",
      moderatedAds: 'Annonces modérées', moderatedAdsDesc: "Notre équipe veille à la qualité des annonces publiées. Les contenus non conformes sont rapidement retirés pour garantir une expérience fiable.",
      support: 'Support réactif', supportDesc: "Une question, un problème ? Notre équipe est disponible pour vous accompagner et vous répondre dans les meilleurs délais.",
    },
    nl: {
      title: 'Over DestockPro',
      missionTitle: 'Onze missie',
      missionText: "Onze missie is om ongebruikt professioneel materiaal een tweede leven te geven. Door bedrijven met elkaar te verbinden, helpen we slapende voorraad te valoriseren, verspilling te verminderen en kwaliteitsmateriaal toegankelijker te maken.",
      whyTitle: 'Waarom DestockPro?',
      whyText: "DestockPro is ontstaan uit een eenvoudige vaststelling: duizenden bedrijven in België, Frankrijk, Luxemburg en Nederland beschikken over ongebruikt professioneel materiaal — slapende voorraad, overschotten, uitlopende series — terwijl anderen precies dit type materiaal zoeken aan een verlaagde prijs.",
      trustTitle: 'Waarom ons vertrouwen',
      trustText: "DestockPro is ontworpen om professionals een betrouwbare en transparante omgeving te bieden. Elk detail van het platform is bedacht om serene en efficiënte uitwisselingen te garanderen.",
      belgianPlatform: 'Europees platform, ontworpen voor professionals',
      belgianDesc: "DestockPro is een Belgisch initiatief dat vertrouwen en eenvoud centraal stelt bij elke uitwisseling tussen bedrijven in België, Frankrijk, Luxemburg en Nederland.",
      stockVal: 'Voorraadwaardering', stockValDesc: 'Transformeer uw slapende voorraad in een commerciële kans.',
      circular: 'Circulaire economie', circularDesc: 'Neem deel aan een verantwoord en duurzaam initiatief.',
      network: 'B2B-netwerk', networkDesc: 'Verbind met andere betrouwbare professionals.',
      prices: 'Concurrerende prijzen', pricesDesc: 'Toegang tot kwaliteitsmateriaal aan een verlaagde prijs.',
      multiSector: 'Multi-sector', multiSectorDesc: 'Zwembad, HVAC, bouw, elektriciteit en meer.',
      trust: 'Vertrouwen', trustDesc: 'Geverifieerde profielen en beveiligde transacties.',
      verifiedProfiles: 'Geverifieerde professionele profielen', verifiedProfilesDesc: "Elke gebruiker vult zijn bedrijfsgegevens in (naam, BTW, adres). U weet altijd met wie u handelt.",
      dataProtected: 'Beschermde gegevens (AVG)', dataProtectedDesc: "Uw gegevens worden veilig gehost en worden nooit doorverkocht. We respecteren strikt de Europese regelgeving.",
      moderatedAds: 'Gemodereerde advertenties', moderatedAdsDesc: "Ons team waakt over de kwaliteit van geplaatste advertenties. Niet-conforme inhoud wordt snel verwijderd om een betrouwbare ervaring te garanderen.",
      support: 'Reactieve ondersteuning', supportDesc: "Een vraag, een probleem? Ons team staat klaar om u te begeleiden en zo snel mogelijk te antwoorden.",
    },
  },

  // ─── How It Works ───────────────────────────────────
  howItWorks: {
    fr: {
      title: 'Comment ça marche',
      subtitle: 'DestockPro facilite la mise en relation entre professionnels. Un seul compte vous permet de vendre et d\'acheter.',
      sellerTitle: 'Vous voulez vendre ?',
      sellerSubtitle: 'Valorisez votre stock dormant en 3 étapes simples',
      buyerTitle: 'Vous voulez acheter ?',
      buyerSubtitle: 'Trouvez du matériel professionnel à prix réduit',
      sellerStep1: 'Créez votre compte pro', sellerStep1Desc: "Inscrivez-vous et complétez votre profil entreprise avec vos informations (nom, TVA, adresse). Un seul compte suffit pour vendre et acheter.",
      sellerStep2: 'Publiez vos annonces', sellerStep2Desc: "Ajoutez votre matériel en quelques minutes : photos, description, prix et catégorie. C'est gratuit et illimité pour les entreprises vérifiées.",
      sellerStep3: 'Échangez et vendez', sellerStep3Desc: "Recevez des demandes d'acheteurs via la messagerie intégrée, négociez et concluez la vente. Boostez vos annonces pour vendre plus vite.",
      buyerStep1: 'Parcourez les annonces', buyerStep1Desc: "Explorez le catalogue par secteur, catégorie, état et prix. Utilisez les filtres pour trouver exactement ce dont vous avez besoin.",
      buyerStep2: 'Sauvegardez vos favoris', buyerStep2Desc: "Ajoutez les annonces qui vous intéressent à vos favoris pour les retrouver facilement depuis votre tableau de bord.",
      buyerStep3: 'Contactez et achetez', buyerStep3Desc: "Échangez directement avec le vendeur via la messagerie sécurisée, négociez les conditions et organisez la transaction.",
      createSellerAccount: 'Publier une annonce',
      browseListings: 'Parcourir les annonces',
      trustTitle: 'Échanges sécurisés entre professionnels',
      trustText: "Tous les utilisateurs de DestockPro sont des professionnels vérifiés. Les profils entreprise, les numéros de TVA et les informations de contact garantissent des échanges de confiance.",
    },
    nl: {
      title: 'Hoe werkt het',
      subtitle: 'DestockPro vergemakkelijkt het contact tussen professionals. Eén account om te verkopen én te kopen.',
      sellerTitle: 'Wilt u verkopen?',
      sellerSubtitle: 'Valoriseer uw slapende voorraad in 3 eenvoudige stappen',
      buyerTitle: 'Wilt u kopen?',
      buyerSubtitle: 'Vind professioneel materiaal aan een verlaagde prijs',
      sellerStep1: 'Maak uw pro-account aan', sellerStep1Desc: "Registreer u en vul uw bedrijfsprofiel in (naam, BTW, adres). Eén account volstaat om te verkopen en te kopen.",
      sellerStep2: 'Plaats uw advertenties', sellerStep2Desc: "Voeg uw materiaal toe in enkele minuten: foto's, beschrijving, prijs en categorie. Gratis en onbeperkt voor geverifieerde bedrijven.",
      sellerStep3: 'Handel en verkoop', sellerStep3Desc: "Ontvang aanvragen van kopers via het berichtensysteem, onderhandel en sluit de verkoop af. Boost uw advertenties om sneller te verkopen.",
      buyerStep1: 'Blader door advertenties', buyerStep1Desc: "Verken de catalogus per sector, categorie, staat en prijs. Gebruik filters om precies te vinden wat u nodig heeft.",
      buyerStep2: 'Bewaar uw favorieten', buyerStep2Desc: "Voeg interessante advertenties toe aan uw favorieten om ze gemakkelijk terug te vinden vanuit uw dashboard.",
      buyerStep3: 'Neem contact op en koop', buyerStep3Desc: "Communiceer rechtstreeks met de verkoper via het beveiligd berichtensysteem, onderhandel over de voorwaarden en organiseer de transactie.",
      createSellerAccount: 'Advertentie plaatsen',
      browseListings: 'Bekijk advertenties',
      trustTitle: 'Beveiligde uitwisselingen tussen professionals',
      trustText: "Alle gebruikers van DestockPro zijn geverifieerde professionals. Bedrijfsprofielen, BTW-nummers en contactgegevens garanderen betrouwbare uitwisselingen.",
    },
  },

  // ─── FAQ ────────────────────────────────────────────
  faq: {
    fr: {
      title: 'Foire aux questions',
      subtitle: 'Trouvez les réponses à vos questions',
      notFound: "Vous n'avez pas trouvé la réponse à votre question ?",
      contactUs: 'Nous contacter',
      items: [
        { q: "Qu'est-ce que DestockPro ?", a: "DestockPro est une marketplace B2B dédiée au déstockage et à la revente de matériel professionnel entre entreprises. Notre plateforme connecte les vendeurs qui souhaitent écouler leur surplus avec les acheteurs à la recherche de matériel à prix réduit." },
        { q: "Qui peut utiliser DestockPro ?", a: "DestockPro est réservé aux professionnels (entreprises, indépendants, artisans). Vous devez créer un compte avec vos informations d'entreprise (nom, numéro de TVA, adresse) pour accéder à toutes les fonctionnalités." },
        { q: "Comment publier une annonce ?", a: "Créez un compte, puis cliquez sur le bouton 'Publier' dans le menu. Remplissez le titre, la description, le prix, le secteur et ajoutez des photos de votre matériel. Votre annonce sera visible immédiatement par tous les acheteurs." },
        { q: "Quels types de matériel puis-je vendre ?", a: "Du matériel professionnel lié aux secteurs : Piscine, HVAC / Chauffage / Climatisation, Plomberie, Construction, Électricité, Jardinage / Espaces verts, Outillage professionnel, et autres. Chaque secteur dispose de sous-catégories détaillées." },
        { q: "La publication d'annonces est-elle gratuite ?", a: "Oui, la publication d'annonces est entièrement gratuite sur DestockPro. Vous pouvez également booster vos annonces avec des options payantes pour augmenter leur visibilité (mise en avant sur la page d'accueil, en tête des résultats de recherche, ou badge de mise en avant)." },
        { q: "Comment fonctionnent les boosts ?", a: "Les boosts sont des options payantes qui augmentent la visibilité de vos annonces. Trois types sont disponibles : affichage en page d'accueil, positionnement en tête des résultats de recherche, et badge de mise en avant. Les paiements sont sécurisés via Stripe (carte bancaire ou Bancontact)." },
        { q: "Comment contacter un vendeur ?", a: "Sur la page d'une annonce, cliquez sur 'Contacter le vendeur'. Notre messagerie intégrée en temps réel vous permet d'échanger directement et en toute sécurité avec le vendeur, sans divulguer vos coordonnées personnelles." },
        { q: "Puis-je sauvegarder des annonces ?", a: "Oui, vous pouvez ajouter des annonces à vos favoris en cliquant sur l'icône cœur. Retrouvez toutes vos annonces sauvegardées dans votre tableau de bord, section 'Mes favoris'." },
        { q: "Qu'est-ce que la vérification d'entreprise ?", a: "La vérification d'entreprise est un processus qui confirme l'authenticité de votre société. Soumettez votre numéro de TVA et vos informations d'entreprise, et notre équipe les vérifiera. Une fois vérifié, un badge apparaît sur votre profil et vos annonces, ce qui renforce la confiance des acheteurs." },
        { q: "DestockPro est-il disponible sur mobile ?", a: "Oui ! DestockPro est une application web progressive (PWA). Vous pouvez l'installer directement sur votre smartphone depuis votre navigateur, sans passer par un app store. Elle fonctionne comme une application native avec un accès rapide depuis votre écran d'accueil." },
        { q: "Comment fonctionne la livraison ?", a: "DestockPro est une plateforme de mise en relation. La livraison et le transport sont organisés directement entre le vendeur et l'acheteur. Les modalités (enlèvement sur site, livraison, transporteur) sont convenues entre les deux parties via la messagerie." },
        { q: "J'ai oublié mon mot de passe, que faire ?", a: "Sur la page de connexion, cliquez sur 'Mot de passe oublié'. Entrez votre adresse email et vous recevrez un lien de réinitialisation par email. Ce lien est valable pour une durée limitée." },
        { q: "Puis-je supprimer mon compte ?", a: "Oui, vous pouvez supprimer votre compte à tout moment depuis votre tableau de bord, dans la section 'Paramètres du compte'. La suppression est définitive et entraîne la suppression de toutes vos annonces et conversations." },
        { q: "Mes données sont-elles protégées ?", a: "Oui, nous respectons la réglementation RGPD. Vos données personnelles sont protégées et ne sont jamais partagées avec des tiers. La messagerie intégrée vous permet de communiquer sans divulguer vos coordonnées. Consultez notre politique de confidentialité pour plus de détails." },
        { q: "Dans quels pays DestockPro est-il disponible ?", a: "DestockPro est principalement actif en Belgique, mais est accessible depuis tous les pays limitrophes (France, Pays-Bas, Luxembourg, Allemagne). La plateforme est disponible en français et en néerlandais." },
      ],
    },
    nl: {
      title: 'Veelgestelde vragen',
      subtitle: 'Vind antwoorden op uw vragen',
      notFound: 'Heeft u het antwoord op uw vraag niet gevonden?',
      contactUs: 'Contacteer ons',
      items: [
        { q: "Wat is DestockPro?", a: "DestockPro is een B2B-marktplaats gewijd aan destocking en doorverkoop van professioneel materiaal tussen bedrijven. Ons platform verbindt verkopers die hun overschotten willen verkopen met kopers die op zoek zijn naar materiaal tegen een verlaagde prijs." },
        { q: "Wie kan DestockPro gebruiken?", a: "DestockPro is voorbehouden aan professionals (bedrijven, zelfstandigen, ambachtslieden). U moet een account aanmaken met uw bedrijfsgegevens (naam, BTW-nummer, adres) om toegang te krijgen tot alle functies." },
        { q: "Hoe plaats ik een advertentie?", a: "Maak een account aan en klik op de knop 'Publiceren' in het menu. Vul de titel, beschrijving, prijs, sector in en voeg foto's van uw materiaal toe. Uw advertentie is direct zichtbaar voor alle kopers." },
        { q: "Welk type materiaal kan ik verkopen?", a: "Professioneel materiaal in de sectoren: Zwembad, HVAC / Verwarming / Airco, Loodgieterij, Bouw, Elektriciteit, Tuinieren / Groenvoorziening, Professioneel gereedschap en overige. Elke sector heeft gedetailleerde subcategorieën." },
        { q: "Is het plaatsen van advertenties gratis?", a: "Ja, het plaatsen van advertenties is volledig gratis op DestockPro. U kunt ook uw advertenties boosten met betaalde opties om hun zichtbaarheid te vergroten (uitgelicht op de startpagina, bovenaan zoekresultaten, of uitgelicht badge)." },
        { q: "Hoe werken boosts?", a: "Boosts zijn betaalde opties die de zichtbaarheid van uw advertenties vergroten. Drie types zijn beschikbaar: weergave op de startpagina, positionering bovenaan zoekresultaten en een uitgelicht badge. Betalingen zijn beveiligd via Stripe (bankkaart of Bancontact)." },
        { q: "Hoe neem ik contact op met een verkoper?", a: "Klik op de advertentiepagina op 'Verkoper contacteren'. Ons realtime geïntegreerd berichtensysteem laat u rechtstreeks en veilig communiceren met de verkoper, zonder uw persoonlijke gegevens te delen." },
        { q: "Kan ik advertenties opslaan?", a: "Ja, u kunt advertenties aan uw favorieten toevoegen door op het hartpictogram te klikken. Vind al uw opgeslagen advertenties in uw dashboard, sectie 'Mijn favorieten'." },
        { q: "Wat is bedrijfsverificatie?", a: "Bedrijfsverificatie is een proces dat de authenticiteit van uw bedrijf bevestigt. Dien uw BTW-nummer en bedrijfsgegevens in, en ons team zal ze controleren. Na verificatie verschijnt er een badge op uw profiel en advertenties, wat het vertrouwen van kopers versterkt." },
        { q: "Is DestockPro beschikbaar op mobiel?", a: "Ja! DestockPro is een Progressive Web App (PWA). U kunt het rechtstreeks op uw smartphone installeren vanuit uw browser, zonder een app store. Het werkt als een native app met snelle toegang vanaf uw startscherm." },
        { q: "Hoe werkt de levering?", a: "DestockPro is een verbindingsplatform. De levering en het transport worden rechtstreeks tussen verkoper en koper geregeld. De modaliteiten (afhaling, levering, transporteur) worden overeengekomen via het berichtensysteem." },
        { q: "Ik ben mijn wachtwoord vergeten, wat nu?", a: "Klik op de inlogpagina op 'Wachtwoord vergeten'. Voer uw e-mailadres in en u ontvangt een resetlink per e-mail. Deze link is beperkt geldig." },
        { q: "Kan ik mijn account verwijderen?", a: "Ja, u kunt uw account op elk moment verwijderen vanuit uw dashboard, in de sectie 'Accountinstellingen'. De verwijdering is definitief en leidt tot het verwijderen van al uw advertenties en gesprekken." },
        { q: "Zijn mijn gegevens beschermd?", a: "Ja, we respecteren de AVG-regelgeving. Uw persoonlijke gegevens zijn beschermd en worden nooit gedeeld met derden. Het geïntegreerde berichtensysteem laat u communiceren zonder uw contactgegevens te onthullen. Raadpleeg ons privacybeleid voor meer details." },
        { q: "In welke landen is DestockPro beschikbaar?", a: "DestockPro is voornamelijk actief in België, maar is toegankelijk vanuit alle buurlanden (Frankrijk, Nederland, Luxemburg, Duitsland). Het platform is beschikbaar in het Frans en Nederlands." },
      ],
    },
  },


  // ─── Not Found (404) ─────────────────────────────────
  notFound: {
    fr: {
      title: 'Page introuvable',
      subtitle: 'La page que vous cherchez n\'existe pas ou a été déplacée.',
      backHome: 'Retour à l\'accueil',
      browseListings: 'Voir les annonces',
    },
    nl: {
      title: 'Pagina niet gevonden',
      subtitle: 'De pagina die u zoekt bestaat niet of is verplaatst.',
      backHome: 'Terug naar startpagina',
      browseListings: 'Bekijk advertenties',
    },
  },


  // ─── Forgot Password ────────────────────────────────
  forgotPassword: {
    fr: {
      title: 'Mot de passe oublié',
      subtitle: 'Entrez votre adresse email et nous vous enverrons un lien de réinitialisation.',
      emailLabel: 'Email',
      emailPlaceholder: 'votre@email.com',
      submitBtn: 'Envoyer le lien',
      sending: 'Envoi...',
      sentTitle: 'Email envoyé',
      sentText: 'Si un compte existe avec l\'adresse <strong>{email}</strong>, vous recevrez un email avec les instructions de réinitialisation.',
      backToLogin: 'Retour à la connexion',
      error: 'Une erreur est survenue. Réessayez.',
    },
    nl: {
      title: 'Wachtwoord vergeten',
      subtitle: 'Voer uw e-mailadres in en we sturen u een link om uw wachtwoord opnieuw in te stellen.',
      emailLabel: 'E-mail',
      emailPlaceholder: 'uw@email.com',
      submitBtn: 'Link verzenden',
      sending: 'Verzenden...',
      sentTitle: 'E-mail verzonden',
      sentText: 'Als er een account bestaat met het adres <strong>{email}</strong>, ontvangt u een e-mail met instructies om uw wachtwoord opnieuw in te stellen.',
      backToLogin: 'Terug naar inloggen',
      error: 'Er is een fout opgetreden. Probeer het opnieuw.',
    },
  },

  // ─── Reset Password ──────────────────────────────────
  resetPassword: {
    fr: {
      title: 'Nouveau mot de passe',
      subtitle: 'Choisissez un nouveau mot de passe pour votre compte.',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      newPlaceholder: 'Min. 6 caractères',
      confirmPlaceholder: 'Retapez le mot de passe',
      submitBtn: 'Réinitialiser',
      submitting: 'Réinitialisation...',
      doneTitle: 'Mot de passe réinitialisé',
      doneText: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
      goToLogin: 'Se connecter',
      invalidLink: 'Lien de réinitialisation invalide.',
      requestNew: 'Demander un nouveau lien',
      minLength: 'Le mot de passe doit contenir au moins 6 caractères.',
      mismatch: 'Les mots de passe ne correspondent pas.',
      errorExpired: 'Lien invalide ou expiré.',
    },
    nl: {
      title: 'Nieuw wachtwoord',
      subtitle: 'Kies een nieuw wachtwoord voor uw account.',
      newPassword: 'Nieuw wachtwoord',
      confirmPassword: 'Wachtwoord bevestigen',
      newPlaceholder: 'Min. 6 tekens',
      confirmPlaceholder: 'Voer het wachtwoord opnieuw in',
      submitBtn: 'Opnieuw instellen',
      submitting: 'Opnieuw instellen...',
      doneTitle: 'Wachtwoord opnieuw ingesteld',
      doneText: 'U kunt nu inloggen met uw nieuwe wachtwoord.',
      goToLogin: 'Inloggen',
      invalidLink: 'Ongeldige resetlink.',
      requestNew: 'Nieuwe link aanvragen',
      minLength: 'Het wachtwoord moet minimaal 6 tekens bevatten.',
      mismatch: 'Wachtwoorden komen niet overeen.',
      errorExpired: 'Ongeldige of verlopen link.',
    },
  },

  // ─── Account Management (Dashboard) ──────────────────
  account: {
    fr: {
      appearance: 'Apparence',
      password: 'Mot de passe',
      changeBtn: 'Modifier',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirm: 'Confirmer',
      newPlaceholder: 'Min. 6 caractères',
      changePassword: 'Changer le mot de passe',
      changing: 'Modification...',
      changed: 'Mot de passe modifié avec succès.',
      changeError: 'Erreur lors du changement.',
      fillAll: 'Remplissez tous les champs.',
      minLength: 'Le mot de passe doit contenir au moins 6 caractères.',
      mismatch: 'Les mots de passe ne correspondent pas.',
      deleteAccount: 'Supprimer mon compte',
      deleteWarning: 'Cette action est irréversible. Tapez votre mot de passe pour confirmer.',
      deletePasswordPlaceholder: 'Votre mot de passe',
      deleteConfirm: 'Confirmer la suppression',
      deleting: 'Suppression...',
      deleted: 'Compte supprimé.',
      deletePassword: 'Entrez votre mot de passe.',
      deleteReasonLabel: 'Avant de partir, aidez-nous à nous améliorer',
      deleteReasonPlaceholder: 'Partagez-nous la raison de votre départ...',
      deleteReasonRequired: 'Merci de nous indiquer la raison, cela nous aide à progresser.',
    },
    nl: {
      appearance: 'Weergave',
      password: 'Wachtwoord',
      changeBtn: 'Wijzigen',
      currentPassword: 'Huidig wachtwoord',
      newPassword: 'Nieuw wachtwoord',
      confirm: 'Bevestigen',
      newPlaceholder: 'Min. 6 tekens',
      changePassword: 'Wachtwoord wijzigen',
      changing: 'Wijzigen...',
      changed: 'Wachtwoord succesvol gewijzigd.',
      changeError: 'Fout bij het wijzigen.',
      fillAll: 'Vul alle velden in.',
      minLength: 'Het wachtwoord moet minimaal 6 tekens bevatten.',
      mismatch: 'Wachtwoorden komen niet overeen.',
      deleteAccount: 'Mijn account verwijderen',
      deleteWarning: 'Deze actie is onomkeerbaar. Typ uw wachtwoord om te bevestigen.',
      deletePasswordPlaceholder: 'Uw wachtwoord',
      deleteConfirm: 'Verwijdering bevestigen',
      deleting: 'Verwijderen...',
      deleted: 'Account verwijderd.',
      deletePassword: 'Voer uw wachtwoord in.',
      deleteReasonLabel: 'Help ons te verbeteren voordat u vertrekt',
      deleteReasonPlaceholder: 'Deel de reden van uw vertrek met ons...',
      deleteReasonRequired: 'Bedankt om de reden op te geven, dit helpt ons te verbeteren.',
    },
  },

  // ─── Share (Listing Detail) ──────────────────────────
  share: {
    fr: {
      share: 'Partager',
      copyLink: 'Copier le lien',
      linkCopied: 'Lien copié !',
      emailSubject: '{title} — DestockPro',
      emailBody: 'Bonjour,\n\nJe vous partage cette annonce sur DestockPro :\n\n{title}\nPrix : {price}\n\n{url}',
      whatsappText: '{title} — {price} sur DestockPro',
    },
    nl: {
      share: 'Delen',
      copyLink: 'Link kopiëren',
      linkCopied: 'Link gekopieerd!',
      emailSubject: '{title} — DestockPro',
      emailBody: 'Hallo,\n\nIk deel deze advertentie op DestockPro met u:\n\n{title}\nPrijs: {price}\n\n{url}',
      whatsappText: '{title} — {price} op DestockPro',
    },
  },

  // ─── Boost ──────────────────────────────────────────
  boost: {
    fr: {
      title: 'Booster mon annonce',
      searchTop: 'Remonter en haut',
      searchTopDesc: 'En tête des résultats de recherche',
      homepage: "Page d'accueil",
      homepageDesc: "Mise en avant sur la page d'accueil",
      badge: 'Badge Top annonce',
      badgeDesc: 'Badge "Top annonce" visible',
      active: 'Actif',
      total: 'Total',
      selectOption: 'Sélectionnez une option',
      pay: 'Payer',
      securePayment: 'Paiement sécurisé par Stripe',
      successTitle: 'Paiement confirmé !',
      successMsg: 'Votre annonce est maintenant boostée. Les options sélectionnées sont actives immédiatement.',
      viewListing: 'Voir mon annonce',
      backDashboard: 'Retour au tableau de bord',
      pendingTitle: 'Paiement en cours de traitement',
      pendingMsg: 'Votre paiement est en cours de vérification. Les boosts seront activés dès la confirmation.',
      failedTitle: 'Paiement échoué',
      failedMsg: "Le paiement n'a pas pu être complété. Aucun montant n'a été débité.",
      verifyingPayment: 'Vérification du paiement...',
      pleaseWait: 'Veuillez patienter quelques instants.',
      paymentError: 'Erreur lors du paiement',
      days: 'j',
    },
    nl: {
      title: 'Mijn advertentie boosten',
      searchTop: 'Naar boven',
      searchTopDesc: 'Bovenaan de zoekresultaten',
      homepage: 'Startpagina',
      homepageDesc: 'Uitgelicht op de startpagina',
      badge: 'Badge Topadvertentie',
      badgeDesc: 'Zichtbaar badge "Topadvertentie"',
      active: 'Actief',
      total: 'Totaal',
      selectOption: 'Selecteer een optie',
      pay: 'Betalen',
      securePayment: 'Beveiligde betaling via Stripe',
      successTitle: 'Betaling bevestigd!',
      successMsg: 'Uw advertentie is nu geboost. De geselecteerde opties zijn onmiddellijk actief.',
      viewListing: 'Mijn advertentie bekijken',
      backDashboard: 'Terug naar dashboard',
      pendingTitle: 'Betaling wordt verwerkt',
      pendingMsg: 'Uw betaling wordt geverifieerd. De boosts worden geactiveerd na bevestiging.',
      failedTitle: 'Betaling mislukt',
      failedMsg: 'De betaling kon niet worden voltooid. Er is geen bedrag afgeschreven.',
      verifyingPayment: 'Betaling verifiëren...',
      pleaseWait: 'Even geduld alstublieft.',
      paymentError: 'Fout bij betaling',
      days: 'd',
    },
  },

  // ─── Terms Page ─────────────────────────────────────
  terms: {
    fr: {
      title: "Conditions d'utilisation",
      lastUpdate: 'Dernière mise à jour : Février 2026',
      sections: [
        { title: '1. Objet', text: "Les présentes conditions générales d'utilisation régissent l'utilisation de la plateforme DestockPro, accessible à l'adresse www.destockpro.be, exploitée par Tenora SRL, société de droit belge, dont le siège social est situé en Belgique, inscrite sous le numéro de TVA BE 1026122616." },
        { title: '2. Accès à la plateforme', text: "L'accès à DestockPro est réservé aux professionnels. Toute inscription implique la fourniture d'informations véridiques relatives à l'entreprise de l'utilisateur. DestockPro se réserve le droit de vérifier ces informations et de suspendre tout compte ne respectant pas cette condition." },
        { title: '3. Inscription et compte', text: "L'utilisateur s'engage à fournir des informations exactes lors de son inscription et à maintenir ces informations à jour. Chaque utilisateur est responsable de la confidentialité de ses identifiants de connexion." },
        { title: '4. Publication d\'annonces', text: "Les vendeurs s'engagent à publier des annonces conformes à la réalité. Les descriptions, photos et prix doivent refléter fidèlement le matériel proposé. DestockPro se réserve le droit de modérer, modifier ou supprimer toute annonce ne respectant pas ces conditions." },
        { title: '5. Transactions', text: "DestockPro facilite la mise en relation entre acheteurs et vendeurs professionnels. Les transactions sont conclues directement entre les parties. DestockPro n'est pas partie aux transactions et ne peut être tenu responsable des litiges éventuels." },
        { title: '6. Responsabilité', text: "DestockPro met tout en œuvre pour assurer le bon fonctionnement de la plateforme. Toutefois, DestockPro ne peut garantir l'absence d'interruptions ou d'erreurs. L'utilisation de la plateforme se fait aux risques et périls de l'utilisateur." },
        { title: '7. Propriété intellectuelle', text: "L'ensemble des éléments constituant la plateforme DestockPro (textes, graphismes, logiciels, bases de données) est la propriété de Tenora SRL. Toute reproduction ou utilisation non autorisée est interdite." },
        { title: '8. Modification des conditions', text: "DestockPro se réserve le droit de modifier les présentes conditions à tout moment. Les utilisateurs seront informés de toute modification substantielle." },
        { title: '9. Droit applicable', text: "Les présentes conditions sont régies par le droit belge. Tout litige sera soumis à la compétence exclusive des tribunaux de Brabant wallon, Belgique." },
        { title: '10. Contact', text: "Pour toute question relative aux présentes conditions, contactez-nous via le formulaire de contact." },
      ],
    },
    nl: {
      title: 'Gebruiksvoorwaarden',
      lastUpdate: 'Laatste update: februari 2026',
      sections: [
        { title: '1. Doel', text: "Deze algemene gebruiksvoorwaarden regelen het gebruik van het DestockPro-platform, toegankelijk op www.destockpro.be, beheerd door Tenora BVBA, een Belgische vennootschap met maatschappelijke zetel in België, ingeschreven onder BTW-nummer BE 1026122616." },
        { title: '2. Toegang tot het platform', text: "Toegang tot DestockPro is voorbehouden aan professionals. Elke registratie impliceert het verstrekken van waarheidsgetrouwe informatie over het bedrijf van de gebruiker. DestockPro behoudt zich het recht voor om deze informatie te verifiëren en elk account dat niet aan deze voorwaarde voldoet op te schorten." },
        { title: '3. Registratie en account', text: "De gebruiker verbindt zich ertoe om correcte informatie te verstrekken bij registratie en deze informatie up-to-date te houden. Elke gebruiker is verantwoordelijk voor de vertrouwelijkheid van zijn inloggegevens." },
        { title: '4. Plaatsen van advertenties', text: "Verkopers verbinden zich ertoe om advertenties te plaatsen die overeenstemmen met de werkelijkheid. Beschrijvingen, foto's en prijzen moeten het aangeboden materiaal getrouw weergeven. DestockPro behoudt zich het recht voor om advertenties die niet aan deze voorwaarden voldoen te modereren, wijzigen of verwijderen." },
        { title: '5. Transacties', text: "DestockPro vergemakkelijkt het contact tussen professionele kopers en verkopers. Transacties worden rechtstreeks tussen de partijen afgesloten. DestockPro is geen partij bij de transacties en kan niet verantwoordelijk worden gesteld voor eventuele geschillen." },
        { title: '6. Aansprakelijkheid', text: "DestockPro doet al het mogelijke om de goede werking van het platform te verzekeren. DestockPro kan echter niet garanderen dat er geen onderbrekingen of fouten optreden. Het gebruik van het platform is op eigen risico van de gebruiker." },
        { title: '7. Intellectueel eigendom', text: "Alle elementen die het DestockPro-platform vormen (teksten, afbeeldingen, software, databases) zijn eigendom van Tenora BVBA. Elke ongeautoriseerde reproductie of gebruik is verboden." },
        { title: '8. Wijziging van voorwaarden', text: "DestockPro behoudt zich het recht voor om deze voorwaarden op elk moment te wijzigen. Gebruikers worden op de hoogte gebracht van elke substantiële wijziging." },
        { title: '9. Toepasselijk recht', text: "Deze voorwaarden worden beheerst door het Belgisch recht. Elk geschil zal exclusief worden voorgelegd aan de rechtbanken van Waals-Brabant, België." },
        { title: '10. Contact', text: "Voor elke vraag over deze voorwaarden, neem contact met ons op via het contactformulier." },
      ],
    },
  },

  // ─── Privacy Page ───────────────────────────────────
  privacy: {
    fr: {
      title: 'Politique de confidentialité',
      lastUpdate: 'Dernière mise à jour : Février 2026',
      sections: [
        { title: '1. Responsable du traitement', text: "Le responsable du traitement des données est Tenora SRL, situé en Belgique. Pour nous contacter, utilisez le formulaire disponible sur la page Contact." },
        { title: '2. Données collectées', text: "Nous collectons les données suivantes lors de votre inscription et utilisation de la plateforme :", list: ["Données d'identification : nom, prénom, email", "Données d'entreprise : nom de société, numéro de TVA, adresse, téléphone", "Données de connexion : adresse IP, date et heure de connexion", "Données relatives aux annonces : descriptions, photos, prix", "Messages échangés via la messagerie intégrée"] },
        { title: '3. Finalités du traitement', text: "Vos données sont traitées pour les finalités suivantes :", list: ["Gestion de votre compte et profil entreprise", "Publication et gestion des annonces", "Mise en relation entre acheteurs et vendeurs", "Amélioration de la plateforme et de l'expérience utilisateur", "Respect de nos obligations légales"] },
        { title: '4. Base légale', text: "Le traitement de vos données est basé sur l'exécution du contrat (conditions d'utilisation), votre consentement, nos intérêts légitimes et le respect de nos obligations légales, conformément au RGPD." },
        { title: '5. Conservation des données', text: "Vos données sont conservées aussi longtemps que votre compte est actif. En cas de suppression de compte, vos données seront effacées dans un délai de 30 jours, sauf obligation légale de conservation." },
        { title: '6. Partage des données', text: "Vos données ne sont pas vendues à des tiers. Certaines informations de votre profil entreprise peuvent être visibles par d'autres utilisateurs de la plateforme dans le cadre des transactions." },
        { title: '7. Vos droits', text: "Conformément au RGPD, vous disposez des droits suivants :", list: ["Droit d'accès à vos données", "Droit de rectification", "Droit à l'effacement", "Droit à la limitation du traitement", "Droit à la portabilité des données", "Droit d'opposition"], textAfter: "Pour exercer ces droits, contactez-nous via le formulaire de contact." },
        { title: '8. Cookies', text: "La plateforme utilise des cookies techniques nécessaires au fonctionnement du site. Aucun cookie publicitaire n'est utilisé sans votre consentement préalable." },
        { title: '9. Sécurité', text: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre l'accès non autorisé, la perte ou la destruction." },
        { title: '10. Contact', text: "Pour toute question relative à la protection de vos données, contactez-nous via le formulaire de contact." },
      ],
    },
    nl: {
      title: 'Privacybeleid',
      lastUpdate: 'Laatste update: februari 2026',
      sections: [
        { title: '1. Verwerkingsverantwoordelijke', text: "De verwerkingsverantwoordelijke is Tenora BVBA, gevestigd in België. Om contact met ons op te nemen, gebruik het formulier op de contactpagina." },
        { title: '2. Verzamelde gegevens', text: "We verzamelen de volgende gegevens bij uw registratie en gebruik van het platform:", list: ["Identificatiegegevens: naam, voornaam, e-mail", "Bedrijfsgegevens: bedrijfsnaam, BTW-nummer, adres, telefoon", "Verbindingsgegevens: IP-adres, datum en tijd van verbinding", "Gegevens met betrekking tot advertenties: beschrijvingen, foto's, prijzen", "Berichten uitgewisseld via het berichtensysteem"] },
        { title: '3. Doeleinden van de verwerking', text: "Uw gegevens worden verwerkt voor de volgende doeleinden:", list: ["Beheer van uw account en bedrijfsprofiel", "Plaatsen en beheren van advertenties", "Contact tussen kopers en verkopers", "Verbetering van het platform en de gebruikerservaring", "Naleving van onze wettelijke verplichtingen"] },
        { title: '4. Rechtsgrondslag', text: "De verwerking van uw gegevens is gebaseerd op de uitvoering van het contract (gebruiksvoorwaarden), uw toestemming, onze legitieme belangen en de naleving van onze wettelijke verplichtingen, conform de AVG." },
        { title: '5. Bewaring van gegevens', text: "Uw gegevens worden bewaard zolang uw account actief is. Bij verwijdering van het account worden uw gegevens binnen 30 dagen gewist, tenzij er een wettelijke bewaarplicht is." },
        { title: '6. Delen van gegevens', text: "Uw gegevens worden niet verkocht aan derden. Bepaalde informatie uit uw bedrijfsprofiel kan zichtbaar zijn voor andere gebruikers van het platform in het kader van transacties." },
        { title: '7. Uw rechten', text: "Conform de AVG beschikt u over de volgende rechten:", list: ["Recht op toegang tot uw gegevens", "Recht op rectificatie", "Recht op verwijdering", "Recht op beperking van de verwerking", "Recht op overdraagbaarheid van gegevens", "Recht van bezwaar"], textAfter: "Om deze rechten uit te oefenen, neem contact met ons op via het contactformulier." },
        { title: '8. Cookies', text: "Het platform maakt gebruik van technische cookies die nodig zijn voor de werking van de site. Er worden geen advertentiecookies gebruikt zonder uw voorafgaande toestemming." },
        { title: '9. Beveiliging', text: "We implementeren passende technische en organisatorische maatregelen om uw gegevens te beschermen tegen ongeautoriseerde toegang, verlies of vernietiging." },
        { title: '10. Contact', text: "Voor elke vraag over de bescherming van uw gegevens, neem contact met ons op via het contactformulier." },
      ],
    },
  },
};

export default translations;
;
